import type { FC } from "react";

const PageNotFound: FC = () => {
  return (
    <div className={"flex h-screen flex-col items-center justify-center"}>
      <span>404</span>
      <span> Страница не найдена</span>
    </div>
  );
};
export default PageNotFound;
